<template>
  <div class="bid-left-top">
    <div class="bid-title">Countdown of participating bidding</div>
    <div class="spaceCenter">
      <div class="bid-time-min spaceCenter">
        <div class="bid-time-text">
          <div class="bid-time-text-big">{{PrefixInteger(mm)}}</div>
          <div class="bid-time-text-sm">MIN</div>
        </div>
      </div>
      <span class="bid-time-spot">:</span>
      <div class="bid-time-sec spaceCenter">
        <div class="bid-time-text">
          <div class="bid-time-text-big">{{PrefixInteger(ss)}}</div>
          <div class="bid-time-text-sm">SEC</div>
        </div>
      </div>
    </div>
    <el-progress
      class="bid-progress common-progress"
      :percentage="sliderVal"
      :show-text="false"
    ></el-progress>
  </div>
</template>

<script>
import { bidTime } from "@/api/bid.js"
export default {
  components: {},
  data() {
    return {
      sliderVal: 10,
      timmer: null,
      targetTime: null,
      time_block: 1000 * 60 * 5,
      time1: "",
      dd: "00",
      HH: "00",
      mm: "00",
      ss: "00",
      systemTime:new Date().getTime()
    };
  },
  computed: {},
  methods: {
    countTime() {
      this.count ++;
      let time2 = this.systemTime + 1000 * this.count;
      this.targetTime = this.time_block - (time2 -this.time1) % this.time_block;

      var m, s;
      if (this.targetTime >= 1000) {
        m = Math.floor(this.targetTime/(1000*60)%60);
        s = Math.floor(this.targetTime/1000%60);
        this.targetTime = this.targetTime - 1000;
        this.mm = m;
        this.ss = s;
      } else {
        this.targetTime = this.time_block;
        this.mm = 0;
        this.ss = 0;
        setTimeout(() => {
          this.$emit("refreshTime");
        },2000)
      }
      this.sliderVal = Math.round((1 - this.targetTime/this.time_block).toFixed(2) * 100);
      this.timmer = window.setTimeout(this.countTime, 1000);
    },
    PrefixInteger(num) {
      return +num < 10 ? "0" + num : num;
    },
    setTime() {
      this.time1 = new Date(
        this.moment().format("YYYY-MM-DD 00:00:00")
      ).getTime();
      this.count = 0;
      this.countTime();
    },
    async getBidTime(){
      this.systemTime = new Date().getTime();
      // await bidTime().then(res => {
      //   this.systemTime = res.result;
      // }).catch(e => {
      //   this.systemTime = new Date().getTime();
      // })
      this.setTime();

    }
  },
  created() {
    this.getBidTime();

  },
  beforeDestroy() {
    window.clearTimeout(this.timmer);
  }
};
</script>
<style scoped lang="scss">
.bid-left-top {
  background: linear-gradient(
    180deg,
    #f5f5f5 0%,
    #f5f5f5 0%,
    #fafafa 56%,
    #ffffff 100%
  );
  border-radius: 0.2rem;
  border: 0.03rem solid #ffffff;
  padding: 0.4rem 0.9rem;
  text-align: center;
  margin: 0.26rem 0 0.24rem 0;
}
.bid-progress {
  margin: 0.35rem 0 0 0;
}
.bid-time-min,
.bid-time-sec {
  width: 1.2rem;
  height: 1.2rem;
  background: #eaf0fd;
  box-shadow: 0 0.02rem 0.4rem 0 rgba(0, 0, 0, 0.05);
  border-radius: 0.04rem;
}
.bid-time-text-big {
  font-size: 0.44rem;
  font-weight: bold;
  color: #3172fd;
  line-height: 0.36rem;
  letter-spacing: 0.01rem;
  margin-bottom: 0.1rem;
}
.bid-time-text-sm {
  font-size: 0.16rem;
  font-weight: 400;
  color: #1f1f1f;
  line-height: 0.19rem;
}
.bid-time-spot {
  font-size: 0.32rem;
  font-weight: bold;
  color: #1f1f1f;
  margin: 0 0.16rem;
}
.bid-title {
  font-size: 0.32rem;
  font-weight: 500;
  color: #ECECEC;
  line-height: 0.38rem;
  margin-bottom: 0.4rem;
}
</style>
